import React from 'react';
import PropTypes from 'prop-types';
import Header from './Header';
import classNames from 'classnames';
import BodyCell from './bodyCells/BodyCell';
import './styles/GroupedList.scss';
import { makeReactColumns } from '../../utils/billingReports';
import ContentLoader from 'react-content-loader';

const ContactRow = ({
  contact,
  columns,
  className,
  ...trProps
}) => <tr className={className} key={contact.id} {...trProps}>
  {
    columns.map((column, i) => (
      <BodyCell {...column} contact={contact} key={i} />
    ))
  }
</tr>;

const GroupedList = ({
  items,
  columns,
  grouping,
  className,
  onSort,
  sort,
  superHeader,
  emptyMessage
}) => {
  if (items.error && items.errorMessage) {
    return (
      <div className='alert alert-danger'>
        {items.errorMessage}
      </div>
    );
  }

  if (items.pending) {
    return (
      <table className={'grouped-list-react'}><tr><td>&nbsp;</td></tr>
        <tbody className={'grouped-list-react-pending'}>
        {
          [...Array(10).keys()].map((e, i) => (
            <tr key={i}>
              <td colSpan={1}>
                <ContentLoader
                  height={5}
                  width={400}
                  speed={2}
                  primaryColor='#f3f3f3'
                  secondaryColor='#ecebeb'
                >
                  <rect x='0' y='0' rx='0' ry='0' width={(Math.random() * (1 - 0.7) + 0.7) * 100} height={5} />
                </ContentLoader>
              </td>
            </tr>
          ))
        }
        </tbody>
      </table>
    );
  }

  const squashedHeaders = [];
  let bodies;
  let headerColumns;

  if (columns[grouping] !== undefined) {
    for (let x = 0; x < columns[grouping].length; x++) {
      for (let y = 0; y < columns[grouping][x].length; y++) {
        if (!squashedHeaders[y] || Object.keys(squashedHeaders[y]).length === 0) {
          squashedHeaders[y] = columns[grouping][x][y];
        }
      }
    }

    headerColumns = makeReactColumns(squashedHeaders, []);

    if (items.length === 0) {
      bodies = (
        <tbody className='grouped-list-react-empty'>
        <tr>
          <td colSpan={columns[grouping][0].length}>
            {emptyMessage}
          </td>
        </tr>
        </tbody>
      );
    } else {
      bodies = items.map(item => (
        <tbody className='grouped-list-react-grouped-rows'>
        <ContactRow
          contact={item}
          columns={makeReactColumns(columns[grouping][item.tier], [])}
          className={'tier' + item.tier}
        />
        </tbody>
      ));
    }
  }

  return (
    <table className={classNames('grouped-list-react', className)}>
      <Header columns={headerColumns} onSort={onSort} sort={sort} superHeader={superHeader} />
      { bodies }
    </table>
  );
};

GroupedList.propTypes = {
  items: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.shape({})
  ]),

  /** Class name(s) to add to the table (optional) */
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),

  /** Metadata about the columns in this contact list */
  columns: PropTypes.object,
  grouping: PropTypes.string
};

GroupedList.defaultProps = {
  items: [],
  columns: null,
  grouping: '',
  className: ''
};

export default GroupedList;
